import { render, staticRenderFns } from "./OsPreditivaArmazem.vue?vue&type=template&id=4037b86c&"
import script from "./OsPreditivaArmazem.vue?vue&type=script&lang=js&"
export * from "./OsPreditivaArmazem.vue?vue&type=script&lang=js&"
import style0 from "./OsPreditivaArmazem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports